import { Chart } from '@frontend/chart/types';

export const hasChartData = (chart: Chart | undefined): boolean => {
    if (!chart?.series?.length) {
        return false;
    }

    return chart.series.some((series) => series.data?.some((point) => point.value !== 0));
};

export const hasChartSeries = (chart: Chart | undefined): boolean => Boolean(chart?.series?.length);
